import React from 'react';
import '../styles/components/ViewImage.scss';
import '../styles/components/options/editPopup.animation.scss';

import closeBtn from '../assets/popup_close.svg';
import ArrowButtons from './ArrowButtons';

export default function viewImage({
	img,
	handleViewState,
	handleLeft,
	handleRight,
}) {
	const handleBackgroundClick = e => {
		if (e.target.classList.value === 'background') handleViewState();
	};

	return (
		<div className='background' onClick={e => handleBackgroundClick(e)}>
			<div className='close_popup'>
				<img src={closeBtn} alt='' onClick={() => handleViewState()} />
			</div>
			{console.log(img)}
			<img src={img} alt='' className='scale-up-center' />
			<ArrowButtons
				handleLeft={() => handleLeft()}
				handleRight={() => handleRight()}
			/>
		</div>
	);
}
